import { Component } from '@angular/core';
import { DynamicContentfulGrid } from 'src/app/@enums/dynamicContentfulComponents';
import { DynamicGridComponent } from '../../contentful/dynamic-grid/dynamic-grid.component';

@Component({
  selector: 'app-checkout-login-bottom',
  templateUrl: './checkout-login-bottom.component.html',
  styleUrls: ['./checkout-login-bottom.component.scss'],
  imports: [DynamicGridComponent],
})
export class CheckoutLoginBottomComponent {
  DynamicContentfulGrid = DynamicContentfulGrid;

  constructor() {}
}
